export default function numberFormatter() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var separator = opts.separator,
      decimals = opts.decimals;

  if (separator) {
    if (decimals) {
      return function (value) {
        return value.toFixed(decimals).replace('.', separator);
      };
    }

    return function (value) {
      return "".concat(value).replace('.', separator);
    };
  }

  if (decimals) {
    return function (value) {
      return value.toFixed(decimals);
    };
  }

  return function (value) {
    return "".concat(value);
  };
}